import { z } from "zod";
import { LinkItemSchema } from "../LinkItem";
export const LinksGroupSchema = z.object({
    label: z.string().optional(),
    links: z.array(LinkItemSchema).optional(),
});
//# sourceMappingURL=index.js.map